export class AppLicenseError extends Error {
  public readonly title: string = 'Missing License';
  public readonly description: string = 'Please reach out to your VBC account admin to grant you the relevant license.';
  constructor() {
    super('AppLicenseError');
  }
}
